import CoverEdit from './CoverEdit'

export default CoverEdit
// eslint-disable-next-line import/export
export * from './CoverEdit'
